module.exports = __webpack_public_path__ + "img/comp_agoro.767b6fdb.png";